module.exports = __webpack_public_path__ + "public/img/gongchang.13234a44.png";